/*eslint no-undef: 0*/
/*eslint comma-dangle: 0*/

import $ from 'jquery'

if(typeof(data) !== 'undefined'){

  const slider_data = data

  $(function(){
    $('.slider').slick({
      infinite: slider_data.infinite || true,
      autoplay: false,
      dots: false,
      arrows: true,
      nextArrow: '<button type="button" class="next-slide"><i class="fa fa-chevron-right"></i></button>',
      prevArrow: '<button type="button" class="prev-slide"><i class="fa fa-chevron-left"></i></button>',
      slidesToShow: 4,
      rows: 0,
      responsive: [
        {
          breakpoint: 1260,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 760,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 300,
          settings: 'unslick', // destroys slick
        },
      ],
    })
  })
}



// WEBPACK FOOTER //
// ./scripts/slider.js